import { ReactNode, useEffect } from "react";
import { View } from "react-native";
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import useStyle from "src/hooks/useStyle";
import IconUpload from "src/icons/IconUpload";
import { color } from "src/styles";
import { paddingXXL, paddingXXXL } from "src/styles/spacing";
import { Text } from "src/swsh-native";

const UploadAreaDisplay = ({
	children,
	isHovering,
}: {
	children: ReactNode;
	isHovering: boolean;
}) => {
	const { theme } = useStyle();

	const isHoveringSV = useSharedValue(+isHovering);
	const contentAnimatedStyle = useAnimatedStyle(
		() => ({
			opacity: 1 - isHoveringSV.value,
		}),
		[isHoveringSV],
	);
	const overlayAnimatedStyle = useAnimatedStyle(
		() => ({
			opacity: isHoveringSV.value,
		}),
		[isHoveringSV],
	);
	useEffect(() => {
		isHoveringSV.value = withTiming(+isHovering);
	}, [isHovering, isHoveringSV]);

	return (
		<View
			style={{
				width: "100%",
				height: "100%",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Animated.View
				pointerEvents="box-none"
				style={[
					{
						width: "100%",
						height: "100%",
						justifyContent: "center",
						alignItems: "center",
					},
					contentAnimatedStyle,
				]}
			>
				{children}
			</Animated.View>
			<Animated.View
				pointerEvents="none"
				style={[
					{
						position: "absolute",
						width: "90%",
						height: "90%",
						alignItems: "center",
						justifyContent: "center",
						borderRadius: 20,
						paddingHorizontal: 120,
						paddingVertical: paddingXXXL,
						borderColor: color.Confirmation[theme],
						borderWidth: 2,
					},
					overlayAnimatedStyle,
				]}
			>
				<IconUpload size={60} />
				<Text
					bold
					style={{
						marginTop: paddingXXL,
					}}
				>
					Drag & Drop Files Here
				</Text>
			</Animated.View>
		</View>
	);
};
export default UploadAreaDisplay;
